import type { ApiAvv, ApiService, ApiStorageLocation, ApiStorageTransaction } from '@Model';
import { FrameEditAvv, FrameEditService, FrameEditStorageLocation } from '@Modules/Stammdaten';
import {
    type AsyncStateUpdate,
    type IGuiBinder,
    useLinkedField,
    useLinkProperty,
} from '@synqo/frontend-component-library';

/** The props of the linked fields Lagerort, Material and AVV of a booking. */
// @ai-generated 2026-10-23T16:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useStorageTransactionLinks(
    binder: IGuiBinder<ApiStorageTransaction>,
    baseApiObjectPath: string,
    requestUpdateState: AsyncStateUpdate<ApiStorageTransaction>,
) {
    const linkStorageLocation = useLinkedField<ApiStorageTransaction, ApiStorageLocation>(
        baseApiObjectPath,
        'storage_location',
        FrameEditStorageLocation,
        false,
        requestUpdateState,
    );
    const linkMaterial = useLinkedField<ApiStorageTransaction, ApiService>(
        baseApiObjectPath,
        'material',
        FrameEditService,
        false,
        requestUpdateState,
    );
    const linkAvv = useLinkedField<ApiStorageTransaction, ApiAvv>(
        baseApiObjectPath,
        'avv',
        FrameEditAvv,
        false,
        requestUpdateState,
    );

    const storageLocationField = useLinkProperty(binder, linkStorageLocation.linkApi);
    const materialField = useLinkProperty(binder, linkMaterial.linkApi);
    const avvField = useLinkProperty(binder, linkAvv.linkApi);

    return {
        storageLocation: { ...storageLocationField, ...linkStorageLocation.events },
        material: { ...materialField, ...linkMaterial.events },
        avv: { ...avvField, ...linkAvv.events },
        linkAvv: (avvId: string) => requestUpdateState(() => linkAvv.linkApi.link(avvId)),
    };
}
